import React, { useState, useEffect, Fragment } from 'react'
import axios from 'axios'
// import Get30Ribbon from '../SaleRibbon/Get30Ribbon'
// import VDayRibbon from '../SaleRibbon/VDayRibbon'

import Ribbon from '../Ribbon/Ribbon'
import Sale25OffRibbon from '../SaleRibbon/Sale25OffRibbon'
import SaleRibbon from '../SaleRibbon/SaleRibbon'
import WarehouseRibbon from '../SaleRibbon/WarehouseRibbon'
import FinalFew25Ribbon from '../SaleRibbon/FinalFew25Ribbon'
import FinalFewSaleRibbon from '../SaleRibbon/FinalFewSaleRibbon'
import Plus25Ribbon from '../SaleRibbon/Plus25Ribbon'
import Plus30Ribbon from '../SaleRibbon/Plus30Ribbon'
import TrunkSaleRibbonBasic from '../SaleRibbon/TrunkSaleRibbonBasic'
import Buy3Get30 from '../SaleRibbon/Buy3Get30'
import Buy3Get35 from '../SaleRibbon/Buy3Get35'
import Buy2Get25 from '../SaleRibbon/Buy2Get25'
import HalloweenThirtyOff from '../SaleRibbon/HalloweenThirtyOff'
import Fall2022drop2 from '../SaleRibbon/Fall2022drop2'
import SummerSaleRibbon from '../SaleRibbon/SummerSaleRibbon'
import BundleRibbon from '../SaleRibbon/BundleRibbon'
import Ribbon25InCart from '../SaleRibbon/Ribbon25InCart'
import BF30OffInCart from '../SaleRibbon/BF30OffInCart'
import BFExtra30OffInCart from '../SaleRibbon/BFExtra30OffInCart'
import UPF50 from '../Flags/UPF50'
// import B2G1FreeRibbon from '../SaleRibbon/B2G1FreeRibbon'
import '../Variant/Variant.scss'

import {
    slugify,
    slugString,
    SIZES,
    fileNameAndExt,
    getUniqueListBy,
    getMatchingProducts,
} from '../../helpers/helpers'

const FILES_URL = 'https://cdn.shopify.com/s/files/1/2338/2917/files/'

const PRODUCT_FILES_URL =
    'https://cdn.shopify.com/s/files/1/2338/2917/products/'

const DEFAULT_IMAGE_SRC =
    'https://cdn.shopify.com/s/files/1/2338/2917/files/default-image.png?v=1628278950'

const DEFAULT_SWATCH_IMAGE_SRC =
    'https://cdn.shopify.com/s/files/1/2338/2917/files/maswatch-default-96.png'

const BOOST_URL =
    'https://services.mybcapps.com/bc-sf-filter/search?shop=monicaandandyonline.myshopify.com&limit=70&fuzzy=2&q='

const tagsArray = ['Buy2Get25', 'Buy3Get30', 'Buy3Get35']

const nurseryTags = ['nursery', 'dropship', 'dropship_product']

// let currentUrl = window.location.href
let currentBaseUrl = window.location.href.split('?')[0]

let baseUrl = 'https://monicaandandy.com'

const ProductTileVariant = React.memo(
    ({ variant, variants, title }) => {
        // console.log('product in Variant.js', product)
        // console.log('matchingProduct in Variant.js', matchingProduct)

        let productTitle = title

        let productHandle = slugify(title)

        const v = variant
        // let title = product.title.split('_')[0]
        let imageSrc
        let imageAlt = v.title

        if (variant && variant.image) {
            // product has variant(s) - use variant image
            imageSrc = variant.image

        }

        let smallImageSource = ''

        let imageSrcArray

        if (imageSrc) {
            imageSrcArray = fileNameAndExt(imageSrc)
            // console.log('imageSrc, imageSrcArray', imageSrc, imageSrcArray)
            smallImageSource =
                PRODUCT_FILES_URL +
                imageSrcArray[0] +
                '_400x400.' +
                imageSrcArray[1]
            // console.log('smallImageSource', smallImageSource)
        } else {
            imageSrc = DEFAULT_IMAGE_SRC
        }

        const [sizes, setSizes] = useState('')
        const [currentPattern, setCurrentPattern] = useState(
            variant.initial_color
        )
        const [currentImage, setCurrentImage] = useState({
            src: smallImageSource ? smallImageSource : imageSrc,
            alt: imageAlt,
        })
        const [value, setValue] = useState('Size')
        const [currentVariantId, setCurrentVariantId] = useState(v.id)
        const [currentVariantPrice, setCurrentVariantPrice] = useState({
            price: variant.price,
            compareAtPrice: variant.compare_at_price,
        })
        const [variantQuantity, setVariantQuantity] = useState(null)

        const [ribbon, setRibbon] = useState(false)
        const [isFinalFew, setIsFinalFew] = useState(false)
        const [isTrunkSale, setIsTrunkSale] = useState(false)
        const [isBuy3Get30, setIsBuy3Get30] = useState(false)
        const [isBuy3Get35, setIsBuy3Get35] = useState(false)
        const [isBuy2Get25, setIsBuy2Get25] = useState(false)

        const [hiddenProduct, setHiddenProduct] = useState()

        // const [isBundle, setIsBundle] = useState(intersection)

        // const [isNursery, setIsNursery] = useState(nurseryIntersection)

        const bundleRibbons = {
            Buy2Get25: <Buy2Get25 />,
            Buy3Get30: <Buy3Get30 />,
            Buy3Get35: <Buy3Get35 />,
        }

        let patternList

        if (variants && variants.length) {
            patternList = variants.filter((p) => {
                console.log('p in productTileVariant', p)
                return (
                    p.product_title.split('_')[0] ===
                    v.product_title.split('_')[0]
                )
            })
            .map((v) => {
                if (v.fulfillment_service.indexOf('cortina') > -1) {
                    return v.initial_color
                } else if (v.inventory_quantity > 0) {
                    return v.initial_color
                }
                return null
            })
        }

        console.log('patternList', patternList)


        // remove any null values from patternList
        patternList = patternList.filter((e) => e != null)

        // console.log('product.title, patternList', product.title, patternList)

        const patterns = [...new Set(patternList)]

        // console.log('product.title, patterns', product.title, patterns)

        let matchingVariants = variants.filter((m) => {
            if (m.fulfillment_service.indexOf('cortina') > -1) {
                return m.product_id === v.product_id
            } else {
                return (
                    m.product_id === v.product_id &&
                    m.initial_color === v.initial_color
                )
            }
        })

        // console.log('matchingVariants', matchingVariants)

        useEffect(() => {
            let sizeList = matchingVariants.map((m) => {
                return {
                    id: m.id,
                    size: m.initial_size,
                    quantity: m.inventory_quantity,
                }
            })

            // console.log('product.title sizeList', product.title, sizeList)

            let sortedSizeList = sizeList.sort(sortFunc)

            sortedSizeList = getUniqueListBy(sortedSizeList, 'id')

            // console.log(
            //     'product.title sortedSizeList',
            //     product.title,
            //     sortedSizeList
            // )

            if (sortedSizeList) {
                // if (product.title.indexOf('Tote + Treat')) {
                //     sortedSizeList = sortedSizeList.slice(0, 1)
                // }
                setSizes(sortedSizeList)
            }

            // eslint-disable-next-line
        }, [])

        let firstVariant = matchingVariants.find(function (el) {
            if (
                (el.fulfillment_service &&
                    el.fulfillment_service.indexOf('carro') > -1) ||
                (el.fulfillment_service &&
                    el.fulfillment_service.indexOf('cortina') > -1)
            ) {
                return el
            } else {
                return el.inventory_quantity > 0
            }
        })

        const handleSwatchClick = (productTitle, pattern) => {
            console.log('handleSwatchClick', productTitle, pattern)
            setCurrentPattern(pattern)

            // update list of matches
            matchingVariants = variants.filter((m) => {
                return (
                    m.product_title.split('_')[0] ===
                        productTitle.split('_')[0] &&
                    m.initial_color === pattern
                )
            })

            console.log('matchingVariants after swatch click', matchingVariants)

            // extract sizes from new matches
            let sizeList = matchingVariants.map((m) => {
                if (m.initial_size === value) {
                    setVariantQuantity(m.inventory_quantity)
                }
                return {
                    id: m.id,
                    size: m.initial_size,
                    quantity: m.inventory_quantity,
                }
            })

            setCurrentVariantPrice({
                price: matchingVariants[0].price,
                compareAtPrice: matchingVariants[0].compare_at_price,
            })

            // console.log('sizeList', sizeList)

            let sortedSizeList = sizeList.sort(sortFunc)

            sortedSizeList = getUniqueListBy(sortedSizeList, 'size')

            if (sortedSizeList) {
                setSizes(sortedSizeList)
            }

            const firstMatchWithInventory = matchingVariants.find(function (
                el
            ) {
                return el.inventory_quantity > 0
            })

            // console.log('firstMatchWithInventory', firstMatchWithInventory)

            if (firstMatchWithInventory) {
                setCurrentImage({
                    src: firstMatchWithInventory.image,
                    alt: imageAlt,
                })
            }

            if (value === 'Size' || value === 'undefined' || value === null) {
                // console.log('swatch selected one size', firstMatchWithInventory.id)
                if (firstMatchWithInventory && firstMatchWithInventory.id) {
                    setCurrentVariantId(firstMatchWithInventory.id)
                    setVariantQuantity(
                        firstMatchWithInventory.inventory_quantity
                    )
                } else {
                    setCurrentVariantId(matchingVariants[0].id)
                    setVariantQuantity(matchingVariants[0].inventory_quantity)
                }
            } else {
                // get variant ID for new pattern variant in selected size
                let selectedSizeVariant = matchingVariants.filter((m) => {
                    return m.initial_size === value
                })
                setCurrentVariantId(
                    selectedSizeVariant[0]?.id ?? matchingVariants[0].id
                )
                setVariantQuantity(
                    selectedSizeVariant[0]?.inventory_quantity ??
                        matchingVariants[0].inventory_quantity
                )

                // if (
                //     intersection &&
                //     intersection !== '' &&
                //     product.title.indexOf('SALE') === -1
                // ) {
                //     setIsBundle(intersection)
                // } else {
                //     setIsBundle(false)
                // }
            }
        }

        const handleSizeSelect = (e) => {
            // console.log('e.target Size', e.target)
            let variantId =
                e.target[e.target.selectedIndex].getAttribute('data-variant-id')
            // console.log('variantId on size select', variantId)
            setVariantQuantity(
                e.target[e.target.selectedIndex].getAttribute('data-inventory')
            )
            setValue(e.target.value)
            setCurrentVariantId(variantId)
        }

        function sortFunc(a, b) {
            let sortingArr = SIZES
            return sortingArr.indexOf(a.size) - sortingArr.indexOf(b.size)
        }

        const getCookie = (cname) => {
            var name = cname + '='
            var decodedCookie = decodeURIComponent(document.cookie)
            var ca = decodedCookie.split(';')
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i]
                while (c.charAt(0) === ' ') {
                    c = c.substring(1)
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length)
                }
            }
            return ''
        }

        const addProductToRegistry = async (
            itemUrl,
            title,
            imageUrl,
            currentVariantId,
            quantity
        ) => {
            let itemDetail = {
                url: itemUrl,
                quantity: 1,
                maRegistryImage: imageUrl,
                title: title,
            }

            let registries = getCookie('ma_registry_id')
            let token = getCookie('access_token')

            if (
                !(window.hasRegistry === 'True' || window.hasRegistry === true)
            ) {
                window.openRegistryModal(itemDetail)
                return
            }

            if (registries && !window.registryId) {
                let allRegistries = JSON.parse(decodeURIComponent(registries))
                if (allRegistries.length > 0) {
                    window.registryId =
                        allRegistries[allRegistries.length - 1].id
                }
            }

            if ((token || token.length) && !window.registryId) {
                await window.verifyToken(itemDetail)
            }

            if (window.registryId) {
                const ADD_REGISTRY_ITEM = `
                mutation addRegistryItemsByVariant($itemUrl: String!, $imageUrl: String!, $registryId: Int!, $title: String!, $quantity: Int!)
                { addRegistryItemsByVariant(itemUrl: $itemUrl, imageUrl: $imageUrl, registryId: $registryId, title: $title, quantity: $quantity) {
                    message
                    }
                }
            `

                const add_product_headers = {
                    'Content-Type': 'application/json',
                    Authorization: 'Token ' + getCookie('access_token'),
                }

                let reqData = {
                    query: ADD_REGISTRY_ITEM,
                    variables: {
                        itemUrl: itemUrl,
                        imageUrl: imageUrl,
                        registryId: Number(window.registryId),
                        title: title,
                        quantity: quantity,
                    },
                }

                let addProductToRegistry = fetch(window.graphqlEndpoint, {
                    method: 'POST',
                    headers: add_product_headers,
                    body: JSON.stringify(reqData),
                })

                addProductToRegistry
                    .then((res) => res.json())
                    .then((data) => {
                        let btnEl = document.querySelectorAll(
                            `.registry-trigger[data-variant-id="${currentVariantId}"]`
                        )
                        if ((data.errors || data.error) && btnEl.length) {
                            btnEl.forEach(
                                (i) =>
                                    (i.innerHTML = 'Try adding after sometime')
                            )
                        } else {
                            localStorage.removeItem('maRePrURL')
                            if (btnEl.length) {
                                btnEl.forEach(
                                    (i) =>
                                        (i.innerHTML = 'Item Added to Registry')
                                )
                            }
                        }
                    })
                    .catch((err) => {
                        console.log('Error while adding product: ', err)
                        let btnEl = document.querySelectorAll(
                            `.registry-trigger[data-variant-id="${currentVariantId}"]`
                        )
                        if (btnEl.length) {
                            btnEl.forEach(
                                (i) =>
                                    (i.innerHTML = 'Try adding after sometime')
                            )
                        }
                    })
            } else {
                window.openRegistryModal(itemDetail)
            }
        }

        useEffect(() => {
            let btnEl = document.querySelectorAll(
                `.registry-trigger[data-variant-id="${currentVariantId}"]`
            )
            if (btnEl.length) {
                btnEl.forEach((i) => (i.innerHTML = 'Add To Registry'))
            }
        }, [currentVariantId])

        // useEffect(() => {
        //     // console.log('product in useEffect ribbon', product)

        //     const substrings = [
        //         'bundle',
        //         'duo',
        //         'ribbed',
        //         'trio',
        //         'trunk-sale',
        //         'Bundle',
        //     ]

        //     if (
        //         product &&
        //         product.vendor &&
        //         product.vendor === 'Monica + Andy'
        //     ) {
        //         if (product.title.indexOf('FINAL FEW') > -1) {
        //             setIsFinalFew(true)
        //         } else {
        //             setRibbon(true)
        //         }
        //         let handle = product.handle
        //         let title = product.title

        //         let found

        //         if (substrings.some((w) => handle.includes(w))) {
        //             found = true
        //         }

        //         if (product.title.indexOf('TRUNK SALE') > -1) {
        //             setIsTrunkSale(true)
        //         } else if (product.title.indexOf('FINAL FEW') > -1 && !found) {
        //             setIsFinalFew(true)
        //         } else if (product.title.indexOf('SALE') > -1) {
        //             setIsFinalFew(true)
        //         } else if (
        //             product.title.indexOf('Long Sleeve Jack + Jill Bodysuit') >
        //                 -1 &&
        //             !found
        //         ) {
        //             setIsBuy3Get30(true)
        //         } else if (
        //             product.title.indexOf('Short Sleeve Jack + Jill Bodysuit') >
        //                 -1 &&
        //             !found &&
        //             !product.title.indexOf('SALE')
        //         ) {
        //             setIsBuy3Get30(true)
        //         } else if (
        //             product.title.indexOf('Groove Pants') > -1 &&
        //             !found
        //         ) {
        //             // console.log('product.title, handle', product.title, handle)
        //             setIsBuy3Get30(true)
        //         } else if (
        //             product.title.indexOf('Coming Home Blanket') > -1 &&
        //             !found &&
        //             !product.title.indexOf('SALE')
        //         ) {
        //             setIsBuy2Get25(true)
        //         } else if (
        //             product.title.indexOf('On the Go One-Piece') > -1 &&
        //             !found &&
        //             !product.title.indexOf('SALE')
        //         ) {
        //             setIsBuy2Get25(true)
        //         } else if (
        //             product.title.indexOf('Top Knot Cap') > -1 &&
        //             !found &&
        //             !product.title.indexOf('SALE')
        //         ) {
        //             setIsBuy3Get35(true)
        //         }

        //         // else {
        //         //     setRibbon(true)
        //         // }
        //     }

        //     return () => setRibbon(false)
        // }, [product])

        // let productHandle

        // if (product && product.handle) {
        //     productHandle = product.handle.split('_')[0]
        //     productHandle = productHandle.replace(/trunk-sale-/g, '')
        //     productHandle = productHandle.replace(/sale-/g, '')
        //     productHandle = productHandle.replace(/-1$/, '')
        //     productHandle = productHandle.replace(/-2$/, '')
        //     productHandle = productHandle.replace(/-3$/, '')
        //     productHandle = productHandle.replace(/-4$/, '')
        //     productHandle = productHandle.replace(/-5$/, '')
        // }

        // useEffect(() => {
        //     const slugS = slugString(productHandle)
        //     const queryUrl = `${BOOST_URL}${slugS}`

        //     const fetchData = async () => {
        //         // get the data from the api
        //         const data = await fetch(queryUrl)
        //         // convert the data to json
        //         const json = await data.json()

        //         console.log('json', json)
        //     }

        //     // call the function
        //     fetchData()
        //         // make sure to catch any error
        //         .catch(console.error)

        //     // console.log('productHandle in useEffect', productHandle, queryUrl)
        //     // fetch(queryUrl).then((res) =>
        //     //     res.json().then((productData) => {
        //     //         // console.log('productData', productData)
        //     //         let productsFromData = productData.products
        //     //         let hiddenP = productsFromData.filter((p) => {
        //     //             return (
        //     //                 p.handle === productHandle &&
        //     //                 p.title.indexOf('hidden') > -1
        //     //             )
        //     //         })

        //     //         setHiddenProduct(hiddenP)

        //     //         // console.log('hiddenP', hiddenP)
        //     //     })
        //     // )

        //     const matching = getMatchingProducts(queryUrl)

        //     console.log('matching in useEffect', matching)
        // }, [productHandle])

        return (
            <Fragment>
                {firstVariant && firstVariant ? (
                    <li
                        className="product"
                        key={firstVariant.id ? firstVariant.id : variant.id}
                    >
                        <div className="height">
                            <div className="product-outer">
                                <div
                                    className="product-image"
                                    data-color={firstVariant.initial_color}
                                >
                                    <a
                                        href={`${baseUrl}/products/${productHandle}${
                                            currentVariantId
                                                ? '?variant=' + currentVariantId
                                                : ''
                                        }`}
                                    >
                                        <img
                                            src={
                                                currentImage
                                                    ? currentImage.src
                                                    : null
                                            }
                                            alt={
                                                imageAlt
                                                    ? imageAlt
                                                    : productHandle +
                                                      ' ' +
                                                      firstVariant.title
                                            }
                                            onError={(e) => {
                                                if (
                                                    e.target.src !==
                                                    DEFAULT_IMAGE_SRC
                                                ) {
                                                    e.target.onerror = null
                                                    e.target.src =
                                                        DEFAULT_IMAGE_SRC
                                                }
                                            }}
                                        />
                                    </a>

                                </div>

                                <div className="product-inner">
                                    <div className="product-top">
                                        <h3 className="product-title">
                                            {productTitle}
                                        </h3>

                                        <div
                                            className="bv-inline-rating"
                                            data-bv-show="inline_rating"
                                            // data-bv-product-id={
                                            //     parentProductId
                                            //         ? parentProductId
                                            //         : currentVariantId
                                            // }
                                            // data-bv-redirect-url={`${baseUrl}/products/${productHandle}${
                                            //     currentVariantId
                                            //         ? '?variant=' +
                                            //           currentVariantId
                                            //         : ''
                                            // }`}
                                            data-bv-seo="false"
                                        ></div>

                                        <p className="product-price">
                                            ${currentVariantPrice.price}{' '}
                                            {currentVariantPrice.compareAtPrice &&
                                            currentVariantPrice.compareAtPrice !==
                                                null ? (
                                                <span className="compare-at-price">
                                                    $
                                                    {
                                                        currentVariantPrice.compareAtPrice
                                                    }
                                                </span>
                                            ) : null}
                                        </p>
                                        <p className="product-available">
                                            Available in {patterns.length}{' '}
                                            {patterns.length === 1
                                                ? 'color'
                                                : 'colors'}
                                        </p>
                                    </div>
                                    <div className="product-bottom">
                                        <div className="product-swatches">
                                            <p className="swatch-heading">
                                                Prints + Colors:{' '}
                                                {currentPattern ? (
                                                    <span>
                                                        {currentPattern}
                                                    </span>
                                                ) : (
                                                    ''
                                                )}
                                            </p>
                                            <ul className="swatch-list nostyle">
                                                {patterns
                                                    ? patterns.map((p,i) => {
                                                          //   console.log(
                                                          //       'p in patterns map',
                                                          //       p
                                                          //   )
                                                          return (
                                                              <li
                                                                  key={
                                                                      i +
                                                                      ' ' +
                                                                      p
                                                                  }
                                                                  className={`swatch ${
                                                                      p ===
                                                                      currentPattern
                                                                          ? 'selected-swatch'
                                                                          : ''
                                                                  }`}
                                                              >
                                                                  <div
                                                                      className="swatch-image"
                                                                      data-product-id={
                                                                          v.id
                                                                      }
                                                                      data-pattern={
                                                                          p
                                                                              ? slugify(
                                                                                    p
                                                                                )
                                                                              : null
                                                                      }
                                                                      aria-label={
                                                                          p
                                                                      }
                                                                      data-balloon-pos="up"
                                                                      onClick={() =>
                                                                          handleSwatchClick(
                                                                              productTitle,
                                                                              p
                                                                          )
                                                                      }
                                                                  >
                                                                      <img
                                                                          src={`${FILES_URL}maswatch-${
                                                                              p
                                                                                  ? slugify(
                                                                                        p
                                                                                    )
                                                                                  : 'default'
                                                                          }-96.png`}
                                                                          alt={`${
                                                                              p
                                                                                  ? p
                                                                                  : 'default'
                                                                          } swatch`}
                                                                          onError={(
                                                                              e
                                                                          ) => {
                                                                              if (
                                                                                  e
                                                                                      .target
                                                                                      .src !==
                                                                                  DEFAULT_SWATCH_IMAGE_SRC
                                                                              ) {
                                                                                  e.target.onerror =
                                                                                      null
                                                                                  e.target.src =
                                                                                      DEFAULT_SWATCH_IMAGE_SRC
                                                                              }
                                                                          }}
                                                                      />
                                                                  </div>
                                                              </li>
                                                          )
                                                      })
                                                    : null}
                                            </ul>
                                        </div>

                                        <div
                                            className={`product-actions ${
                                                sizes && sizes.length < 2
                                                    ? 'no-sizes'
                                                    : null
                                            }`}
                                        >
                                            <div className="product-sizes">
                                                <select
                                                    className={`product-size-select select-css`}
                                                    onChange={handleSizeSelect}
                                                    value={value}
                                                    data-value={value}
                                                    data-variant-id={
                                                        currentVariantId
                                                    }
                                                >
                                                    <option
                                                        key="null-size-option"
                                                        className="default-option"
                                                        data-variant-id={null}
                                                    >
                                                        Size
                                                    </option>
                                                    {sizes && sizes
                                                        ? sizes.map((s) => {
                                                              // console.log('s in size select', s)
                                                              if (s) {
                                                                  return (
                                                                      <option
                                                                          key={`${s.id}-${s.size}-${s.quantity}`}
                                                                          data-variant-id={
                                                                              s.id
                                                                          }
                                                                          value={
                                                                              s.size
                                                                          }
                                                                          data-inventory={
                                                                              s.quantity
                                                                          }
                                                                          className={
                                                                              s.quantity >
                                                                              0
                                                                                  ? 'available'
                                                                                  : 'disabled'
                                                                          }
                                                                          disabled={
                                                                              s.quantity >
                                                                              0
                                                                                  ? false
                                                                                  : true
                                                                          }
                                                                      >
                                                                          {
                                                                              s.size
                                                                          }
                                                                      </option>
                                                                  )
                                                              }
                                                              return false
                                                          })
                                                        : null}
                                                </select>
                                            </div>
                                            <img src="https://tags.srv.stackadapt.com/conv?cid=qBKDsUM8E94E9aNhrIzfYt" width="1" height="1"/><img src="https://tags.srv.stackadapt.com/rt?sid=haPbm9jsSu8GCp1D75rSX5" width="1" height="1"/>
                                            <div className="product-add-to-cart">
                                                <form
                                                    action="/cart/add"
                                                    acceptCharset="UTF-8"
                                                    encType="multipart/form-data"
                                                    className="product-atc"
                                                >
                                                    <input
                                                        type="hidden"
                                                        min="1"
                                                        name="quantity"
                                                        value="1"
                                                    />
                                                    <input
                                                        type="hidden"
                                                        name="id"
                                                        value={currentVariantId}
                                                    />
                                                    {sizes &&
                                                    sizes.length > 2 ? (
                                                        <button
                                                            type="submit"
                                                            className={`large-button button-atc ${
                                                                (value &&
                                                                    value ===
                                                                        'Size') ||
                                                                (variantQuantity !==
                                                                    null &&
                                                                    variantQuantity <=
                                                                        0)
                                                                    ? 'disabled'
                                                                    : null
                                                            }`}
                                                            // disabled={
                                                            //     value &&
                                                            //     value === 'Size'
                                                            //         ? true
                                                            //         : false
                                                            // }
                                                            data-variant-id={
                                                                currentVariantId
                                                            }
                                                            data-balloon-blunt
                                                            data-balloon-pos="up"
                                                            aria-label={
                                                                (value &&
                                                                    value ===
                                                                        'Size') ||
                                                                (variantQuantity !==
                                                                    null &&
                                                                    variantQuantity <=
                                                                        0)
                                                                    ? 'Please select a size'
                                                                    : null
                                                            }
                                                        >
                                                            Add To Cart
                                                        </button>
                                                    ) : (
                                                        <button
                                                            type="submit"
                                                            className={`large-button button-atc button-no-sizes`}
                                                            data-variant-id={
                                                                currentVariantId
                                                            }
                                                        >
                                                            Add To Cart
                                                        </button>
                                                    )}
                                                </form>
                                            </div>
                                        </div>
                                        <div className="registry-actions">
                                            <span
                                                className={`registry-trigger ${
                                                    (sizes &&
                                                        sizes.length > 2 &&
                                                        value &&
                                                        value === 'Size') ||
                                                    (variantQuantity !== null &&
                                                        variantQuantity <= 0)
                                                        ? 'disabled'
                                                        : null
                                                }`}
                                                data-variant-id={
                                                    currentVariantId
                                                }
                                                data-balloon-blunt
                                                data-balloon-pos="up"
                                                aria-label={
                                                    (sizes &&
                                                        sizes.length > 2 &&
                                                        value &&
                                                        value === 'Size') ||
                                                    (variantQuantity !== null &&
                                                        variantQuantity <= 0)
                                                        ? 'Please select a size'
                                                        : null
                                                }
                                                onClick={() =>
                                                    addProductToRegistry(
                                                        `${currentBaseUrl}/products/${
                                                            productHandle
                                                        }${
                                                            currentVariantId
                                                                ? '?variant=' +
                                                                  currentVariantId
                                                                : null
                                                        }`,
                                                        productTitle,
                                                        currentImage
                                                            ? currentImage.src
                                                            : null,
                                                        currentVariantId,
                                                        1
                                                    )
                                                }
                                            >
                                                Add To Registry
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                ) : null}
            </Fragment>
        )
    }
)

export default ProductTileVariant
